import tw from 'twin.macro';
import React from 'react';

export const Label = tw.p`text-xs tracking-[0.35px]`;
export const Button = tw.button``;
